import { FormsInputDropdown } from '@platform/components';
import { Control } from 'react-hook-form';
import { challengeOptions } from '../dashboard/business-challenges/org-business-challenges-form/consts';

type BusinessChallengeSelectionDropdownProps = {
  // eslint-disable-next-line
  control: Control<any>;
  label: string;
  challengeNumber: 'first' | 'second' | 'third';
};

export const BusinessChallengeSelectionDropdown = (
  props: BusinessChallengeSelectionDropdownProps,
) => {
  const { label, control, challengeNumber } = props;

  return (
    <FormsInputDropdown
      control={control}
      name={`${challengeNumber}BusinessChallenge`}
      label={label}
      placeholder='Select one'
      items={challengeOptions}
      type='default'
    />
  );
};
